<template>
<div>
    <div class="row mb-2">
        <div class="col-12 col-md-5 pe-0">
            <label for="">Tipe Filter</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-sliders font-13"></i>
                <select v-model="mutatedTypeFilter" @change="onChangeTypeFilter($event)" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                    <option value="daily" selected="">Harian</option>
                    <option value="monthly">Bulanan</option>
                    <option value="range">Range Tanggal</option>
                    <option value="all">Semua</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'daily'">
            <label for="">Tanggal</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-calendar font-12"></i>
                <input type="date" class="form-control rounded-xs" id="c5" @change="onChangeFilterDaily($event)" v-model="mutatedDailyTime">
                <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'range'">
            <div class="row">
                <div class="col-md-6 pe-0">
                    <label for="">Tanggal Mulai</label>
                    <div class="form-custom form-label form-border form-icon mb-0">
                        <i class="bi bi-calendar font-12"></i>
                        <input type="date" class="form-control rounded-xs" id="c5" @change="onChangeRangeDateFrom($event)" v-model="mutatedRangeDateFrom">
                        <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                        <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                    </div>
                </div>
                <div class="col-md-6 pe-0">
                    <label for="">Tanggal Sampai</label>
                    <div class="form-custom form-label form-border form-icon mb-0">
                        <i class="bi bi-calendar font-12"></i>
                        <input type="date" class="form-control rounded-xs" id="c5" @change="onChangeRangeDateTo($event)" v-model="rangeDateTo">
                        <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                        <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'monthly'">
            <label for="">Bulan</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-calendar font-12"></i>
                <select v-model="mutatedMonthlyTime" @change="onChangeFilterMonthly($event)" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Bulan -</option>
                    <option value="01" data-name="">Januari</option>
                    <option value="02">Febuari</option>
                    <option value="03">Maret</option>
                    <option value="04">April</option>
                    <option value="05">Mei</option>
                    <option value="06">Juni</option>
                    <option value="07">Juli</option>
                    <option value="08">Agustus</option>
                    <option value="09">September</option>
                    <option value="10">Oktober</option>
                    <option value="11">November</option>
                    <option value="12">Desember</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-12 col-md-3 pe-0">
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-list-ol font-13"></i>
                <select v-model="mutatedTingkatFilter" @change="onChangeFilterTingkat($event)" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Tingkat -</option>
                    <option v-for="item in tingkats" :key="item.id" :value="item.id">{{ item.nama }}</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-4 pe-0">
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-bookmarks-fill font-13"></i>
                <select v-model="mutatedRombelFilter" @change="onChangeFilterRombel($event)" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Kelas -</option>
                    <option v-for="item in rombels" :key="item.id" :value="item.id">{{ item.nama }}</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-5 pe-0">
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-person-circle font-13"></i>
                <select v-model="mutatedStudentFilter" @change="onChangeFilterStudent($event)" class="form-select rounded-xs" id="c8" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Siswa -</option>
                    <option v-for="item in students" :key="item.id" :value="item.id">{{ item.nama }}</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { 
    mapActions, mapState 
} from 'vuex'

export default {
    props: ['typeFilter', 'dailyTime', 'monthlyTime', 'rangeDateFrom', 'rangeDateTo', 'tingkatFilter', 'rombelFilter', 'studentFilter', 'getDataDaily', 'getDataMonthly', 'getDataAll', 'getDataRange', 'monthLabel', 'dayLabel'],
    name: 'ReportFilter',
    data() {
        return {
            mutatedTypeFilter: this.typeFilter,
            mutatedDailyTime: this.dailyTime,
            mutatedMonthlyTime: this.monthlyTime,
            mutatedRangeDateFrom: this.rangeDateFrom,
            mutatedRangeDateTo: this.rangeDateTo,
            mutatedTingkatFilter: this.tingkatFilter,
            mutatedRombelFilter: this.rombelFilter,
            mutatedStudentFilter: this.studentFilter,
            rombels: [],
            students: [],
        }
    },
    async created() {
        await this.getTingkat()
        let responseGetRombel = await this.getRombel()
        this.rombels = responseGetRombel.data
        
        let responseGetStudents = await this.getStudents(this.mutatedRombelFilter)
        this.students = responseGetStudents.data
    },
    methods: {
        ...mapActions('data', ['getTingkat', 'getRombel', 'getStudents']),
		onChangeFilterReport(event) {
			if (event.target.value == 'monthly') this.selectedMontly = ''
		},
        async onChangeTypeFilter(event) {
            const value = event.target.value;
            this.$emit('update:typeFilter', value);
            if(value == "daily") {
                this.$emit('get-data-daily')
            }else if(value == "monthly") {
                this.$emit('get-data-monthly')
            }else if(value == "range") {
                this.$emit('get-data-range')
            }else{
                this.$emit('get-data-all')
            }
        },
        async onChangeFilterTingkat(event) {
            if (this.mutatedTingkatFilter == '') {
                this.rombels = []
                this.mutatedRombelFilter = ''
                this.$emit('update:rombelFilter', '')
                this.mutatedStudentFilter = ''
                this.$emit('update:studentFilter', '')
            } else {
                let responseGetRombel = await this.getRombel(this.mutatedTingkatFilter)
                this.rombels = responseGetRombel.data
            }
            this.students = []

            this.$emit('update:tingkatFilter', event.target.value)

            this.handleGetData()
        },
        async onChangeFilterRombel(event) {
            if (this.mutatedRombelFilter == '') {
                this.students = []
                this.mutatedStudentFilter = ''
                this.$emit('update:studentFilter', '')
            } else {
                let responseGetStudents = await this.getStudents(this.mutatedRombelFilter)
                this.students = responseGetStudents.data
            }

            this.$emit('update:rombelFilter', event.target.value)

            this.handleGetData()
        },
        async onChangeFilterStudent(event) {
            this.$emit('update:studentFilter', event.target.value)

            this.handleGetData()
        },
        async onChangeFilterDaily(event) {
            this.$emit('update:dailyTime', event.target.value)
            this.$emit('get-data-daily')
        },
        async onChangeFilterMonthly(event) {
            const theTarget = event.target.options[event.target.options.selectedIndex];
            this.$emit('update:monthLabel', theTarget.text)
            this.$emit('update:monthlyTime', event.target.value)
            this.$emit('get-data-monthly')
        },
        async onChangeRangeDateFrom(event) {
            this.$emit('update:rangeDateFrom', event.target.value)
            this.$emit('get-data-range')
        },
        async onChangeRangeDateTo(event) {
            this.$emit('update:rangeDateTo', event.target.value)
            this.$emit('get-data-range')
        },
        handleGetData() {
            if (this.mutatedTypeFilter == 'monthly') this.$emit('get-data-monthly')
            else this.$emit('get-data-daily')
        }
    },
    computed: {
        ...mapState('data', {
            tingkats: state => state.tingkats
        }),
    }
}
</script>

<style scoped>
</style>
